import React from "react";
import logger from "logger";
import { getStyleJSON } from "Utils/Common";
import Constants from "Utils/Constants";
import Header from "Common/Header";
import store from "store";
import { withRouter } from "react-router-dom";
import errordialog from "Common/errordialog";
import { getData } from "Utils/Common";
import { ToolbarButton } from "Common/ToolbarButton";
import Grid from "@material-ui/core/Grid";
import Tasklet from "TaskHistory/Tasklet";
import Toolbar from "@material-ui/core/Toolbar";

export const goToRunningTasks = (history) => {
  return refresh().then(() => {
    history.push(Constants.runningtasks);
  });
};

const refresh = () => {
  const accounts = store.getState().rootScope.accounts;
  logger.log("accounts", accounts);
  var dataparams = {
    datakey: "runningtasks",
    accounts,
  };
  store.dispatch({ type: "ISLOADING", payload: true });
  return getData(dataparams, ({ data: { ok, data } }) => {
    logger.log("running tasks response", ok, data);
    if (ok && data.runningtasks) {
      store.dispatch({ type: "SETRUNNINGTASKS", payload: data.runningtasks });
    }
    store.dispatch({ type: "ISLOADING", payload: false });
  }).catch((error) => {
    logger.log(
      "Error",
      error.message,
      error.error && error.error.message,
      error.response
    );
    store.dispatch({ type: "ISLOADING", payload: false });
    errordialog.showError(error.response.data.message);
  });

  /*
   */
};

class RunningTasksComponent extends React.Component {
  constructor(props) {
    super();
    logger.log("Constructor called!");
    this.state = {};
  }

  render = () => {
    logger.log("this.state", this.state);
    const accountdata = store.getState().rootScope;
    let taskCount = 0;
    const tasks = accountdata.runningtasks;
    if (tasks) {
      taskCount = tasks.length;
    }

    return (
      <div>
        <Header />
        <br />
        <Toolbar
          style={getStyleJSON(
            `background-color: var(--menubarbackgroundcolor);min-height: auto;`
          )}
        >
          <div layout="row" className="layout-row">
            <div>
              <h1>Currently Running Tasks: {taskCount}</h1>
              <div>
                <ToolbarButton
                  label={"Back"}
                  onClick={this.props.history.goBack}
                  tooltip={"Go Back."}
                />
                <ToolbarButton
                  label={"Refresh"}
                  onClick={refresh}
                  tooltip={"Refresh task data"}
                />
              </div>
            </div>
          </div>
        </Toolbar>
        <br />

        <div className="komform">
          <Grid container spacing={1}>
            {tasks &&
              tasks.map((task) => {
                return (
                  <Grid item>
                    <Tasklet task={task} showOwner={true} showUser={false} />
                  </Grid>
                );
              })}
          </Grid>
        </div>
        <br />
      </div>
    );
  };
}

export const RunningTasks = withRouter(RunningTasksComponent);
